import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const nav = useNavigate();

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const timer = setInterval(async () => {
      attempts++;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setStatus("paid"); clearInterval(timer); }
        else if (r.data.payment_status === "expired") { setStatus("expired"); clearInterval(timer); }
      } catch { /* ignore */ }
      if (attempts > 15) { setStatus("timeout"); clearInterval(timer); }
    }, 2000);
    return () => clearInterval(timer);
  }, [sessionId]);

  return (
    <Layout>
      <div className="mx-auto max-w-2xl px-4 py-24 text-center">
        {status === "polling" && (
          <>
            <Loader2 className="w-16 h-16 text-red-500 mx-auto animate-spin" />
            <h1 className="hero-title text-3xl text-white mt-6">Confirming your deposit…</h1>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-16 h-16 text-green-500 mx-auto" />
            <h1 className="hero-title text-4xl text-white mt-6">You're scheduled.</h1>
            <p className="text-slate-300 mt-4">Deposit received. Dylan will call to lock in a day and time.</p>
            <button data-testid="success-home" onClick={() => nav("/")} className="mt-8 btn-red px-8 py-4 rounded-sm">Back Home</button>
          </>
        )}
        {(status === "expired" || status === "error" || status === "timeout") && (
          <>
            <XCircle className="w-16 h-16 text-amber-500 mx-auto" />
            <h1 className="hero-title text-3xl text-white mt-6">Something's off with that payment.</h1>
            <p className="text-slate-400 mt-4">Please call <a className="text-red-500 underline" href="tel:2704054083">270-405-4083</a>.</p>
          </>
        )}
      </div>
    </Layout>
  );
}
